import { render, staticRenderFns } from "./CustomTabList.vue?vue&type=template&id=7cdb4a28"
import script from "./CustomTabList.vue?vue&type=script&lang=ts"
export * from "./CustomTabList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cdb4a28')) {
      api.createRecord('7cdb4a28', component.options)
    } else {
      api.reload('7cdb4a28', component.options)
    }
    module.hot.accept("./CustomTabList.vue?vue&type=template&id=7cdb4a28", function () {
      api.rerender('7cdb4a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/CustomTabList.vue"
export default component.exports